///    CORE
import PgLogo from '../../assets/images/core/logo.png';
import PlayForRealPopup from '../../assets/images/core/play-for-real-popup.png';
import PfCheck from '../../assets/images/core/pf-check.png';
import BigFilter from '../../assets/images/core/big-filter.png';
import Loader from '../../assets/images/core/loader.png';
import ShadEf from '../../assets/images/core/shad-ef.png';
import UserBonus from '../../assets/images/core/user-bonus.png';
import XMas from '../../assets/images/core/x-mas.png';
import { gameStore } from '../../store/gameStore';

const fakeRenderImages = [
  // CORE
  PgLogo,
  PlayForRealPopup,
  PfCheck,
  BigFilter,
  Loader,
  ShadEf,
  UserBonus,
  XMas,
];

export const FakeRenderImages = () => {
  let count = 0;
  return (
    <div className='fake-render-images-container' style={{ display: 'none' }}>
      {fakeRenderImages?.map((item) => {
        return (
          <img
            src={item}
            alt=''
            style={{ display: 'none' }}
            onLoad={() => {
              gameStore.updateIsFakeImagesLoaded(++count, fakeRenderImages?.length);
            }}
            key={item}
          />
        );
      })}
    </div>
  );
};
